export const CLEAR_SUBCOMPANY = 'CLEAR_SUBCOMPANY';
export const DELETE_SUBCOMPANY = 'DELETE_SUBCOMPANY';
export const GET_SUBCOMPANIES = 'GET_SUBCOMPANIES';
export const GET_SUBCOMPANY = 'GET_SUBCOMPANY';
export const MODIFY_SUBCOMPANY = 'MODIFY_SUBCOMPANY';
export const SAVE_SUBCOMPANY = 'SAVE_SUBCOMPANY';
export const TOGGLE_SUBCOMPANY = 'TOGGLE_SUBCOMPANY';
export const RESET_SUBCOMPANIES = 'RESET_SUBCOMPANIES';



// WEBPACK FOOTER //
// src/modules/secured/modules/subcompanies/constants/subcompanies_constants.js